/** Staged Customize draft (localStorage) — not a built-in Brand/Gray/Dark skin. */
export const SKIN_CUSTOMIZATION = "customization";

export const CUSTOMIZATION_SKIN = {
    id: SKIN_CUSTOMIZATION,
    title: "Customization",
    description: "Staged color and logo changes for this store.",
};

export const THEME_DRAFT_STORAGE_PREFIX = "email-theme-draft";
